import api from '../api'

const userBaseUrl = '/People/api/People'
const baseUrl = '/academy/api/Admin'

const moocUsersProvider = {
  getSearchUsers(params) {
    return api.get('/Idp/Admin/v2/UserList' + params)
  },

  getUser(params) {
    return api.get(`${baseUrl}/EditUser/${params}`)
  },

  addUsersExcel(productId, productType, params) {
    return api.post(`${baseUrl}/ProductPeoples?productId=${productId}&productType=${productType}`, params)
  },

  addSearchUser(params) {
    return api.post(`/university/api/AdminCourse/ProductPeople`, params)
  },

  creatSearchUser(params) {
    return api.post(`/university/api/AdminCourse/People`, params)
  },

  updateUser(params = {}) {
    return api.put(`${baseUrl}/User`, params)
  },

  deleteCourseUser(params) {
    return api.delete(`/university/api/AdminCourse/ProductPeople/${params}`)
  },

  createTeacherUser(params = {}) {
    return api.post(userBaseUrl, params)
  },

  createAdminFacaltyUser(params = {}) {
    return api.post('/Idp/Admin/CreateUser', params)
  },

  updateAdminFacaltyUser(params = {}) {
    return api.post('/Idp/Admin/UpdateUser', params)
  },
  getAdminFacaltyUser(params = {}) {
    return api.get('/Idp/Admin/GetUser?userId=' + params)
  },

  getUserById(params) {
    return api.get(`${userBaseUrl}/GetById?peopleId=${params}`)
  },

  getAvailableRoles() {
    return api.get(`/Idp/Admin/AvailableRoles`)
  },

  updateUserRole(params = {}) {
    return api.put(`/university/api/AdminCourse/ProductPeopleRole`, params)
  },
}

export default moocUsersProvider
